module.exports = __webpack_public_path__ + "static/img/b1.02d2d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b1.png
// module id = jt0N
// module chunks = 1